
	//$(function() {
	$(document).ready(function() {
		
		// ----------------------------------------------
		// awards slider
		// ----------------------------------------------
		var reviewBlock = $('[data-review-carousel]');
		reviewBlock.each(function() {
			var self			= $(this),
				reviewItems	= self.find(".my-review-carousel"),
				item_to_show	= self.data("item-to-show"),
				item_dots		= self.data("item-dots"),
				item_dots_mb	= self.data("item-dots-mb"),
				item_arrows		= self.data("item-arrows"),
				item_arrows_mb	= self.data("item-arrows-mb"),
				iconArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"/></svg>';
			
			var $slidebar = self.find('.progress-bar');
			
			if (reviewItems.length > 0) {
				if (!reviewItems.hasClass('slick-initialized')) {
					reviewItems.slick({
						mobileFirst: true,
						adaptiveHeight: false,
						infinite: false,
						vertical: false,
						slidesToShow: 2,
						slidesToScroll: 1,
						dots: item_dots_mb,
						arrows: item_arrows_mb,
						nextArrow: '',//<button type="button" class="slick-arrow slick-next" aria-label="Slide Next">' + iconArrow + '</button>',
						prevArrow: '',//<button type="button" class="slick-arrow slick-prev" aria-label="Slide Prev">' + iconArrow + '</button>',
						customPaging: function(slider, i) {
							return '<button type="button" class="dot-pill"></button>';
						},
						responsive: [
							{
								breakpoint: 552,
								settings: {
									dots: item_dots_mb,
									arrows: item_arrows_mb,
									slidesToShow: 2,
									slidesToScroll: 1,
								}
							},
							{
								breakpoint: 1100,
								settings: {
									dots: item_dots,
									arrows: item_arrows,
									slidesToShow: 3,
									slidesToScroll: 1,
								}
							},
							{
								breakpoint: 1300,
								settings: {
									dots: item_dots,
									arrows: item_arrows,
									slidesToShow: item_to_show,
									slidesToScroll: 1,
								}
							}
						]
					});
				}
			}

			function update_review_slidebar(currentSlide){
				var slick = reviewItems.slick('getSlick');
				var totalSlides = slick.slideCount;
				var slidesToShow = slick.options.slidesToShow;
				var percent = ((currentSlide + slidesToShow) / totalSlides) * 100;
				percent = Math.min(100, percent);
				$slidebar.css('width', percent + '%');
			}

			reviewItems.on('afterChange', function(event, slick, currentSlide){
				update_review_slidebar(currentSlide);
			});

			// Initialize filled scrollbar on load
			update_review_slidebar(0);
		});
		
		// ----------------------------------------------
		// layers slider
		// ----------------------------------------------
		
		var layerBlock = $('[data-layer-carousel]');
		layerBlock.each(function() {
			var self			= $(this),
				layerCarousel	= self.find(".my-layer-carousel"),
				item_to_show	= self.data("item-to-show"),
				item_dots		= self.data("item-dots"),
				item_dots_mb	= self.data("item-dots-mb"),
				item_arrows		= self.data("item-arrows"),
				item_arrows_mb	= self.data("item-arrows-mb");
			
			function initLayerSlick() {
				if (window.innerWidth < 992) {
					if (! layerCarousel.hasClass('slick-initialized')) {
						layerCarousel.slick({
							mobileFirst: true,
							adaptiveHeight: false,
							infinite: false,
							vertical: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: item_dots_mb,
							arrows: item_arrows_mb,
							nextArrow: '',
							prevArrow: '',
							customPaging: function(slider, i) {
								return '<button type="button" class="dot-pill"></button>';
							},
						});
						
						// slideDown all answers
						layerCarousel.find('.breakaway_answere_part').slideDown(0);
						
						// when slick initializes or changes slide
						layerCarousel.on('init reInit afterChange', function (event, slick, currentSlide) {
							var i = (currentSlide ? currentSlide : 0);
							var $slides = $(slick.$slides);

							// Remove all active states
							$slides.find('.breakaway_faq_part').removeClass('active_question');

							// Add active to visible slide only
							var $current = $slides.eq(i);
							$current.find('.breakaway_faq_part').addClass('active_question');
							
							$('.image_no').removeClass('active_layer');
							var layer_no = $current.find('.breakaway_question_part').attr('data-layer-no');
							$('.layer_no_'+layer_no).addClass('active_layer');
							if(layer_no == '1') {
								$('.layer_no_7').addClass('active_layer');
							}
						});

						// trigger manually after first init
						layerCarousel.on('init', function (event, slick) {
							var $slides = $(slick.$slides);
							var $first = $(slick.$slides[0]);
							$slides.find('.breakaway_answere_part').slideDown(0);
							$first.find('.breakaway_faq_part').addClass('active_question');
							
							var layer_no = $first.find('.breakaway_question_part').attr('data-layer-no');
							$('.layer_no_'+layer_no).addClass('active_layer');
							if(layer_no == '1') {
								$('.layer_no_7').addClass('active_layer');
							}
						});
					}
				}
				else {
					// desktop behavior
					if (layerCarousel.hasClass('slick-initialized')) {
						layerCarousel.slick('unslick');
					}
					// open only first FAQ
					var $faqParts = self.find('.breakaway_faq_part');
					$faqParts.removeClass('active_question').find('.breakaway_answere_part').slideUp(0);
					$faqParts.first().addClass('active_question');
					$faqParts.first().find('.breakaway_answere_part').slideDown(0);
					
					$('.image_no').removeClass('active_layer');
					var layer_no = 1;
					$('.layer_no_'+layer_no).addClass('active_layer');
					if(layer_no == '1') {
						$('.layer_no_7').addClass('active_layer');
					}
				}
			}
			if (layerCarousel.length > 0) {
				initLayerSlick();// Init on load
				$(window).on('resize', function () {
					initLayerSlick(); // recheck on resize
				});
			}
		});
		
		$(document).on('click', '.breakaway_question_part', function(e) {
			$('.image_no').removeClass('active_layer');
			
			if ($(this).closest('.breakaway_faq_part').hasClass("active_question")) {
				$(this).closest('.breakaway_faq_part').removeClass('active_question');
				$(this).next('.breakaway_answere_part').slideUp();
			}
			else {
				$('.breakaway_faqs_list').find('.breakaway_faq_part').each(function() {
					$(this).removeClass('active_question');
					$(this).find('.breakaway_answere_part').slideUp(200);
				});
				
				$(this).closest('.breakaway_faq_part').addClass('active_question');
				$(this).next('.breakaway_answere_part').slideDown();
				
				var layer_no = $(this).attr('data-layer-no');
				$('.layer_no_'+layer_no).addClass('active_layer');
				if(layer_no == '1') {
					$('.layer_no_7').addClass('active_layer');
				}
			}
		});
		
		// ----------------------------------------------
		// features/why-love slider
		// ----------------------------------------------
		
		var featureBlock = $('[data-feature-carousel]');
		featureBlock.each(function() {
			var self			= $(this),
				featureItems	= self.find(".my-feature-carousel"),
				item_to_show	= self.data("item-to-show"),
				item_dots		= self.data("item-dots"),
				item_dots_mb	= self.data("item-dots-mb"),
				item_arrows		= self.data("item-arrows"),
				item_arrows_mb	= self.data("item-arrows-mb"),
				iconArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"/></svg>';
			
			var $slidebar = self.find('.progress-bar');
			
			if (featureItems.length > 0) {
				if (!featureItems.hasClass('slick-initialized')) {
					featureItems.slick({
						mobileFirst: true,
						adaptiveHeight: false,
						infinite: false,
						vertical: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: item_dots_mb,
						arrows: item_arrows_mb,
						nextArrow: '<button type="button" class="slick-arrow slick-next" aria-label="Slide Next">' + iconArrow + '</button>',//',
						prevArrow: '<button type="button" class="slick-arrow slick-prev" aria-label="Slide Prev">' + iconArrow + '</button>',//',
						customPaging: function(slider, i) {
							return '<button type="button" class="dot-pill"></button>';
						},
						responsive: [
							{
								breakpoint: 552,
								settings: {
									dots: item_dots_mb,
									arrows: item_arrows_mb,
									slidesToShow: 1,
									slidesToScroll: 1,
								}
							},
							{
								breakpoint: 1100,
								settings: {
									dots: item_dots,
									arrows: item_arrows,
									slidesToShow: 2,
									slidesToScroll: 1,
								}
							},
							{
								breakpoint: 1300,
								settings: {
									dots: item_dots,
									arrows: item_arrows,
									slidesToShow: item_to_show,
									slidesToScroll: 1,
								}
							}
						]
					});
				}
			}
		});
		
		$(document).on('click', '.my-feature-title', function(e) {
			$(this).closest('.my-feature-info-part').find('.plusminus-toggle').toggleClass('collapsed');
			$(this).closest('.my-feature-info-part').find('.my-feature-text').toggleClass('collapsed');
		});
		
		// ----------------------------------------------
		// proven videos slider
		// ----------------------------------------------
		
		var provenBlock = $('[data-proven-carousel]');
		provenBlock.each(function() {
			var self			= $(this),
				provenItems		= self.find(".my-proven-carousel"),
				item_to_show	= self.data("item-to-show"),
				item_dots		= self.data("item-dots"),
				item_dots_mb	= self.data("item-dots-mb"),
				item_arrows		= self.data("item-arrows"),
				item_arrows_mb	= self.data("item-arrows-mb"),
				iconArrow = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"/></svg>';
			
			var $slidebar = self.find('.progress-bar');
			
			if (provenItems.length > 0) {
				if (!provenItems.hasClass('slick-initialized')) {
					provenItems.slick({
						mobileFirst: true,
						adaptiveHeight: false,
						infinite: false,
						vertical: false,
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: item_dots_mb,
						arrows: item_arrows_mb,
						nextArrow: '<button type="button" class="slick-arrow slick-next" aria-label="Slide Next">' + iconArrow + '</button>',//',
						prevArrow: '<button type="button" class="slick-arrow slick-prev" aria-label="Slide Prev">' + iconArrow + '</button>',//',
						customPaging: function(slider, i) {
							return '<button type="button" class="dot-pill"></button>';
						},
						responsive: [
							{
								breakpoint: 552,
								settings: {
									dots: item_dots_mb,
									arrows: item_arrows_mb,
									slidesToShow: 1,
									slidesToScroll: 1,
								}
							},
							{
								breakpoint: 1100,
								settings: {
									dots: item_dots,
									arrows: item_arrows,
									slidesToShow: 2,
									slidesToScroll: 1,
								}
							},
							{
								breakpoint: 1300,
								settings: {
									dots: item_dots,
									arrows: item_arrows,
									slidesToShow: item_to_show,
									slidesToScroll: 1,
								}
							}
						]
					});
				}
			}
		});
		
		// ----------------------------------------------
		// compare slider
		// ----------------------------------------------
		
		const compare_container	= document.getElementById("improved-grid_container");
		const afterBlock		= compare_container.querySelector(".com_botanical_mattress");
		const compare_handle	= document.getElementById("compare-handle");
		const compare_line		= compare_container.querySelector(".compare-line");

		let dragging = false;
		let lastPercent = 50;
		let compareRect = null;

		function applyClip(percent) {
			if (window.innerWidth > 992) {
				afterBlock.style.clipPath = `inset(0 0 0 0)`; // full width (side-by-side)
			} else {
				afterBlock.style.clipPath = `inset(0 0 0 ${percent}%)`;
				compare_handle.style.left = `${percent}%`;
				compare_line.style.left = `${percent}%`;
			}
		}

		function setPosition(clientX) {
			if (window.innerWidth > 992) {
				applyClip(0);
				return;
			}
			const rect = compare_container.getBoundingClientRect();
			let x = clientX - rect.left;
			x = Math.max(0, Math.min(x, rect.width));

			const percent = (x / rect.width) * 100;
			lastPercent = percent;
			applyClip(percent);
		}

		function start(e) {
			dragging = true;
			e.preventDefault();
			compareRect = compare_container.getBoundingClientRect();
		}

		function end() {
			dragging = false;
		}

		function move(e) {
			if (!dragging) return;
			const clientX = e.touches ? e.touches[0].clientX : e.clientX;
			//requestAnimationFrame(() => setPosition(clientX)); // old way
			
			let x = clientX - compareRect.left;
			x = Math.max(0, Math.min(x, compareRect.width));
			const percent = (x / compareRect.width) * 100;
			lastPercent = percent;
			requestAnimationFrame(() => applyClip(percent));
		}

		// mouse + touch listeners
		compare_handle.addEventListener("mousedown", start);
		window.addEventListener("mouseup", end);
		window.addEventListener("mousemove", move);

		compare_handle.addEventListener("touchstart", start);
		window.addEventListener("touchend", end);
		window.addEventListener("touchmove", move);

		// smart resize detection using ResizeObserver (no polling)
		const resizeObserver = new ResizeObserver(() => applyClip(lastPercent));
		resizeObserver.observe(document.body);

		// initial apply
		applyClip(lastPercent);
		
		// ----------------------------------------------
		// FAQs category slider
		// ----------------------------------------------
		
		const kstab_menu_list = document.querySelector('.kstab_menu_list');
		const kstab_menu_item = document.querySelectorAll('.kstab_menu_item');

		let activeDrag = false;

		// Drag scroll functionality
		kstab_menu_list.addEventListener('mousemove', (drag) => {
			if (!activeDrag) return;
			kstab_menu_list.scrollLeft -= drag.movementX;
			kstab_menu_list.classList.add('dragging');
		});
		document.addEventListener('mouseup', () => {
			activeDrag = false;
			kstab_menu_list.classList.remove('dragging');
		});
		kstab_menu_list.addEventListener('mousedown', () => activeDrag = true);
		/*
		kstab_menu_item.forEach((kstab, index) => {
			tab.addEventListener('click', () => {
				kstab_menu_item.forEach(t => t.classList.remove('active'));
				kstab.classList.add('active');
			});
		});*/
		
    	// used for FAQs on BB page
    	$('.kstab_menu_list .kstab_menu_item:first-child').addClass('active');
    	$('.kstab_content').hide();
    	$('.kstab_content:first').show();
    	
    	$('.kstab_menu_list .kstab_menu_item').click(function(){
    		$('.kstab_menu_list .kstab_menu_item').removeClass('active');
    		$(this).addClass('active');
    		$('.kstab_content').hide();
            
    		var activeTab = $(this).attr('data-target');
    		$('#'+activeTab).fadeIn();
    		return false;
    	});
		$('.f01__customer_faqs_question').on('click', function() {
			$(this).closest('.f01__customer_faqs_item').find('.plus-minus-toggle').toggleClass('collapsed');
			$(this).closest('.f01__customer_faqs_item').find('.f01__customer_faqs_answere').toggleClass('collapsed');
		});
		


		
		
		// ----------------------------------------------
		// Porduct image+thumb slider
		// ----------------------------------------------
		
		var $product_slider_for = $('.product-slider-for');
		var $product_slider_nav = $('.product-slider-nav');
		var navInited = false;

		function init_product_slider() {
			if (window.innerWidth < 768) {
				if (!navInited) {
					// MAIN SLIDER
					$product_slider_for.slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						fade: true,
						asNavFor: '.product-slider-nav'
					});
					// THUMB SLIDER
					$product_slider_nav.slick({
						slidesToShow: 5,         // how many thumbs visible on mobile
						slidesToScroll: 1,
						asNavFor: '.product-slider-for',
						dots: true,
						arrows: false,
						centerMode: false,
						focusOnSelect: true,
						infinite: false
					});
					navInited = true;
				}
			}
			// DESKTOP: destroy slick to get 2-per-line grid
			else {
				if (navInited) {
					$product_slider_for.slick('unslick');
					$product_slider_nav.slick('unslick');
					navInited = false;
				}
			}
		}
		init_product_slider(); // run on load
		
		$(window).on('resize', function() {
			init_product_slider(); // run on resize
		});


		
		
	});
	